import React from 'react'
import {
  play_icon,
  aplicacao,
} from '../../sharedcomponents/ImageScope'
import './Section1.css'
export default function Section(){
  return(
    <>
      <div>
            <section className=" container video-sec-area pb-100 pt-40" id="about">
             <div className="container">
            <div className="row justify-content-start align-items-center">
                <div className="col-lg-6 video-right justify-content-center align-items-center d-flex">
                    <div className="overlay overlay-bg"></div>
                    <a className="play-btn" href="https://www.youtube.com/watch?v=ARA0AxrnHdM"><img className="img-fluid"
                            src={play_icon} alt=""/></a>
                </div>
                <div className="col-lg-6 video-left">
                    <h6>Video sobre HS Design.</h6>
                    <h1>Saiba mais sobre <br/>
                        a nossa história</h1>
                    <p><span>Somos uma gráfica focada no clinte.</span></p>
                    <p>A HS Design Lda e uma Empresa de direito 100% angolano, localizada no Bairro Cassenda, Rua 6
                        Bloco 77b, ap/12rc.
                        No conjunto dos desafios que se colocam ao pais destacam-se a prossecução dos objectivos, a
                        divulgação empresarial, assim como o trabalho artístico.</p>

                    <p> Fundamentalmente para o desenvolvimento de nacional e divulgação do trabalho gráfico e têxtil,
                        no qual ira alcançar as metas definidas.
                        Foi o campo de intervenção na qual a HS Design Lda, escolheu para interferir na nossa sociedade.
                    </p>
                    <p className="abou-txt-end">
                        Na nossa gráfica trabalhamos com impressões, timbragens de t-shirts, chapeus, fazemos logotipos,
                        cartões de visitas, flayers e muito mais.
                    </p>

                </div>
            </div>
        </div>
      </section>
      </div>
    </>
  );
}